import { ArrowRight } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import alertIcon from '@/assets/icons/popup/laranja.svg';
import refund from '@/assets/icons/popup/refund.svg';

import { PopupsProps } from '@/context/CustomPopupsContext/types';
import { useToast } from '@/context/ToastContext';

import { useCustomPopups } from '@/hooks/useCustomPopups/useCustomPopups';

import CloseButton from '@/components/CustomPopups/components/CloseButton';

import { Body, Button, Container, Content, LinkContainer, Text } from './styles';

interface IPopupTemplate3 {
  id: number;
  headline: string;
  content: HTMLElement | string;
  confirmButtonText: string;
  onConfirm?: () => void;
}

const PopupTemplate3 = ({ id }: IPopupTemplate3) => {
  const { setPopupsList } = useCustomPopups();
  const toast = useToast();
  const navigate = useNavigate();

  const handleClosePopup = () => {
    setPopupsList((state: PopupsProps[]) =>
      state.map((item) => ({
        ...item,
        popup_is_open: item.id === id ? false : item.popup_is_open,
      })),
    );
  };

  const handlePopupConfirmation = () => {
    try {
      navigate('/reembolso');
      handleClosePopup();
    } catch {
      toast.error('Não foi possível redirecionar para a tela de reembolsos!');
    }
  };

  return (
    <Container key={id}>
      <CloseButton onClose={() => handleClosePopup()} />
      <Body>
        <Content>
          <img src={refund} alt="Logo" />
          <Text>Atualização de Reembolso</Text>
          <div style={{ position: 'relative' }}>
            <img
              src={alertIcon}
              alt="Alerta"
              style={{
                position: 'absolute',
                top: '-6px',
                right: '-10px',
                transform: 'translateX(-50%)',
              }}
            />
            <Button>Pendente</Button>
          </div>
          <LinkContainer onClick={handlePopupConfirmation}>
            <a>Acesse a página e corrija as informações</a>
            <ArrowRight size={16} />
          </LinkContainer>
        </Content>
      </Body>
    </Container>
  );
};

export default PopupTemplate3;
